import removeDiacritics from './remove-diacritics';
const search = (needle, haystack) => {
    needle = removeDiacritics(needle);
    const regex = new RegExp(`\\b${needle}`, 'gi');
    return haystack
        .map(({ region, cities }) => ({
        region,
        cities: cities.filter(({ name }) => removeDiacritics(name).match(regex)), //filter out the cities that don't match the search query
    }))
        .filter(({ region, cities }) => cities.length > 0 || removeDiacritics(region.name).match(regex)); //keep the regions that: contain at least one city or their name matches the search query
};
export const boldText = (needle, haystack) => {
    needle = removeDiacritics(needle);
    const textWithoutDiacritics = removeDiacritics(haystack);
    //important: using a global flag will not return the index of the match
    const re = new RegExp('\\b' + needle, 'i');
    if (!textWithoutDiacritics.match(re)) {
        return haystack;
    }
    // use to find the index where the word starts
    const position = textWithoutDiacritics.match(re).index;
    const patternText = haystack.substr(position, needle.length);
    // use to match the text that should be replaced with strong text
    const re2 = new RegExp('(' + patternText + ')', 'i');
    // the text that comes from the index of the match and to the end of the string
    const subText = haystack.substr(position);
    //see if there are other words after the one that contains the match
    const subTextToSpace = subText.substr(0, subText.indexOf(' ', needle.length));
    if (subTextToSpace) {
        //we only make bold the match in the string up to the first space
        let text = haystack.substr(0, position) + subTextToSpace.replace(re2, '<b>$1</b>');
        //take the rest of the words
        const textFromSpace = subText.substr(subText.indexOf(subTextToSpace) + subTextToSpace.length);
        if (textFromSpace.match(re)) {
            text += boldText(textFromSpace, needle);
        }
        else {
            text += textFromSpace;
        }
        return text;
    }
    return haystack.substr(0, position) + subText.replace(re2, '<b>$1</b>');
};
export const indicateMatch = (match, places) => {
    return places.map(({ region, cities }) => ({
        region: Object.assign(Object.assign({}, region), { name: boldText(match, region.name) }),
        cities: cities.map((city) => (Object.assign(Object.assign({}, city), { isTop: false, name: boldText(match, city.name) }))),
    }));
};
export default search;
